// Copyright (c) 2016 Wildcard Corp. www.wildcardcorp.com

export const environment = {
  production: true
};



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/environment.ts